import PropTypes from 'prop-types';
import React, {Component} from 'react';
import classNames from 'classnames';
import './StarRatingBase.less';

/**
 * StarRatingBase
 *
 */

class StarRatingBase extends Component {
    static propTypes = {
        /** Raw Rating Number.  StarRating will round to the correct half star. */
        rating: PropTypes.number.isRequired,
        /** The StarRating size variation, one of: '12'|'16'|'24'|'32'. The value corresponds to the px height of the stars. 'sm' and 'lg' are deprecated and map to 12 and 24 respectively.  */
        size: PropTypes.oneOf(['12', '16', '24', '32', 'lg', 'sm']),
        /** Flag to determine if stars should use stroke not default fill */
        useStroke: PropTypes.bool
    }

    static defaultProps = {
        rating: 0,
        size: '16',
        useStroke: false
    }

    constructor(props) {
        super(props);

        const roundRating = this.roundRating(props.rating);

        this.state = {
            roundRating,
            ratingClass: this.getRatingClass(roundRating)
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.rating !== this.props.rating) {
            let roundRating = this.roundRating(nextProps.rating);

            this.setState({
                roundRating,
                ratingClass: this.getRatingClass(roundRating)
            });
        }
    }

    shouldComponentUpdate(nextProps) {
        return (nextProps.rating !== this.props.rating || nextProps.className !== this.props.className);
    }

    get getSize() {
        const {size} = this.props;

        switch (size) {
            case 'lg':
                return '24';
            case 'sm':
                return '12';
            default:
                return size;
        }
    }

    roundRating(rawRating) {
        return (Math.round(rawRating * 2) / 2).toFixed(1);
    }

    getRatingClass(roundedRating) {
        let affix = this.roundRating(roundedRating).replace('.0', '').replace('.5', '-5');

        return `StarRating__stars StarRating__stars--${affix}`;
    }

    getStarSVG = (useStroke) => {
        const pathAttributes = {
            'stroke': (useStroke) ? 'currentColor' : 'none',
            'strokeWidth': (useStroke) ? '1' : 'none',
            'fill': (useStroke) ? 'none' : 'currentColor'
        };

        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={this.getSize} height={this.getSize} viewBox="0 0 24 24">
                <path {...pathAttributes} vectorEffect="non-scaling-stroke" d="M11.7 18l-5.5 3.8A.8.8 0 0 1 5 21l1.8-6c0-.2 0-.4-.2-.5L2.2 9.9a.7.7 0 0 1 .5-1.2l5.8-.6c.2 0 .4 0 .4-.3l2.4-5.3a.8.8 0 0 1 1.4 0l2.4 5.3c0 .2.2.3.4.3l5.8.6a.7.7 0 0 1 .5 1.2l-4.5 4.6v.5l1.7 6a.8.8 0 0 1-1.2.8L12.3 18a.5.5 0 0 0-.6 0z"/>
            </svg>
        );
    }

    renderStars = (className, useStroke) => {
        const star = this.getStarSVG((useStroke));

        return (
            <div className={className}>
                {star}{star}{star}{star}{star}
            </div>
        );
    }

    render() {
        const {rating, size, useStroke, className, children, ...rest} = this.props; // eslint-disable-line no-unused-vars
        const {roundRating, ratingClass} = this.state;
        const sizeVariant = `${this.getSize}px`;
        const inputVariant = (children) ? 'Input' : '';
        const ratingClasses = classNames('StarRating', `StarRating${inputVariant}--${sizeVariant}`, className);
        const bottomStarClasses = classNames('StarRating__stars', `StarRating${inputVariant}--${sizeVariant}`);
        const topStarClasses = classNames('StarRating__stars', 'text-emphasis', `StarRating${inputVariant}--${sizeVariant}`, ratingClass);

        return (
            <div className={ratingClasses}>
                {!(roundRating === '5.0' && !children) &&
                    <div className={bottomStarClasses}>
                        {this.renderStars(classNames('StarRating__svg'), useStroke)}
                    </div>
                }
                {!(roundRating === '0.0') &&
                <div className={topStarClasses}>
                    {this.renderStars(classNames('StarRating__svg', `StarRating${inputVariant}--${sizeVariant}`, 'StarRating__svg--top'))}
                </div>
                }
                {children}
            </div>
        );
    }
}

export default StarRatingBase;
